"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _RadialData2 = _interopRequireDefault(require("./RadialData"));

var PageRequestsRadialData =
/*#__PURE__*/
function (_RadialData) {
  (0, _inherits2.default)(PageRequestsRadialData, _RadialData);

  function PageRequestsRadialData() {
    (0, _classCallCheck2.default)(this, PageRequestsRadialData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageRequestsRadialData).apply(this, arguments));
  }

  (0, _createClass2.default)(PageRequestsRadialData, [{
    key: "init",
    value: function init(grade) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(PageRequestsRadialData.prototype), "init", this).call(this, grade);
      this.displayRecommendationValue = '< 30';
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, 30, 80);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      this.score = Math.min(grade, 100);
    }
  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      this.displayValue = grade;
    }
  }]);
  return PageRequestsRadialData;
}(_RadialData2.default);

var _default = PageRequestsRadialData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/PageRequestsRadialData.js
// module id = 271
// module chunks = 0